import { useModel as _useModel, defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Popup',
  props: {
    "modelValue": {},
    "modelModifiers": {}
  },
  emits: ["update:modelValue"],
  setup: function setup(__props) {
    var model = _useModel(__props, "modelValue");
    return function (_ctx, _cache) {
      var _component_van_popup = _resolveComponent("van-popup");
      return _openBlock(), _createBlock(_component_van_popup, {
        round: "",
        position: "bottom",
        show: model.value,
        "onUpdate:show": _cache[0] || (_cache[0] = function ($event) {
          return model.value = $event;
        }),
        style: {
          height: '555px'
        }
      }, {
        default: _withCtx(function () {
          return [_renderSlot(_ctx.$slots, "default")];
        }),
        _: 3
      }, 8, ["show"]);
    };
  }
});